// utils
import { lazy } from 'react';
// styling
import styled from 'styled-components/macro';
// assets
import animation from '@assets/uecomix-gifs/NOTED.webp';
import { useMediaQuery } from 'react-responsive';
import LazyImage from './LazyImage';
// components
const Fade = lazy(() => import('@mui/material/Fade'));

const Wrapper = styled.div`
  .lottie {
    width: 50%;
    max-width: 240px;
    margin: 40px 0 20px;
  }
`;

const styles = {
  uecomixWriteGif: {
    width: '26%',
    padding: '50px 0 50px 0',
  },

  h4: {
    fontSize: '35px',
  },

  uecomixWriteGifM: {
    width: '70%',
    padding: '50px 0 50px 0',
    h4: {
      fontSize: '22px',
    }
  },
};

const NothingFound = ({ text }) => {

  const isMobile = useMediaQuery({ maxWidth: 700 });

  return (
    <Wrapper className="d-flex flex-column align-items-center">
      <div style={!isMobile ? styles.uecomixWriteGif : styles.uecomixWriteGifM}>
        <LazyImage src={animation} alt="UE Comix Noting" />
      </div>
      <h4 className="title" style={!isMobile ? styles.h4 : styles.uecomixWriteGifM.h4}>{text}</h4>
    </Wrapper>
  );
}

export default NothingFound